export type DictionaryState = {
  projectScopeOptions: Array<any>;
  projectType: string
};

export const state: DictionaryState = {
  projectScopeOptions: [], // 业务范围,
  projectType: 'oa',
};
